import React, { Component, useRef } from 'react';
import './styles.css';
import Auth from '../api/ApiSession';
import _, { result } from 'lodash';
import CustomerProfile2 from './createNewUserComponents/customerProfile2';
import LandDetails2 from './myCustomersComponents/landDetails';
import AddAssets from './createNewUserComponents/addAssets';
import IrradianceDetails from './myCustomersComponents/irradiance';
import LandDetailsWithMap from './myCustomersComponents/landDetailsWithMap';
const authCall = new Auth();
const CreateNewUser = (props) => {
  const btnref = useRef();const btn1ref = useRef();const btn2ref = useRef();const btn3ref = useRef();const btn4ref = useRef();
  let stepperList = ["Customer Profile", "Land Details", "Gateway Info", "Assets", "Irradiance Info", "Income Details"]
  const [isProfileError, setIsProfileError] = React.useState(false)
  const [isLandError, setIsLandError] = React.useState(false)
  const [isGateWayError, setIsGateWayError] = React.useState(false)
  const [isAssetsError, setIsAssetsError] = React.useState(false)
  const [isIrradianceError, setIsIrradianceError] = React.useState(false)
  const [isIncomeError, setIsIncomeError] = React.useState(false)
  const [snackBarObj, setSnackBarObj] = React.useState({})
  const [selectedId, setSelectedId] = React.useState("")
  const [selectedIndex, setSelectedIndex] = React.useState(0)
  const [formData, setFormData] = React.useState({
    "customerId": "",
    personalData: [
      { "PropName": "Customer Type", "PropValue": "" },
      { "PropName": "First Name", "PropValue": "" },
      { "PropName": "Last Name", "PropValue": "" },
      { "PropName": "Email", "PropValue": "" },
      { "PropName": "Contact Number", "PropValue": "" },
      { "PropName": "Address", "PropValue": "" },
      { "PropName": "City", "PropValue": "" },
      { "PropName": "State", "PropValue": "" },
      { "PropName": "Country", "PropValue": "" },
      { "PropName": "Pincode", "PropValue": "" },
      { "PropName": "No. of Entrepreneurs (Men)", "PropValue": "" },
      { "PropName": "No. of Entrepreneurs (Women)", "PropValue": "" },
      { "PropName": "Photo", "PropValue": "data:image/png;base64,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" }
    ],
    "detailsInfo": [
      {
        "infoType": "Land Details",
        "infoData": [
          { PropName: "Land Owned (In acres)", PropValue: "" },
          // { PropName: "Search Address", PropValue: "" },
          { PropName: "Address", PropValue: "" },
          { PropName: "City", PropValue: "" },
          { PropName: "State", PropValue: "" },
          { PropName: "Country", PropValue: "" },
          { PropName: "Pincode", PropValue: "" },
          { PropName: "Latitude", PropValue: "" },
          { PropName: "Longitude", PropValue: "" },
          { PropName: "No. of Farmers Men", PropValue: "0" },
          { PropName: "No. of Farmers Women", PropValue: "0" },
          { PropName: "No. of Farmers Working", PropValue: "" }
          
        ],
        "irRadianceData": null,
        "DeviceDetails": null
      }, {
        "infoType": "Gateway Info",
        "driveNo": "",
        "driveInstalledDate": "",
        "infoData": [{ PropName: "Gateway ID", PropValue: "" }],
        "irRadianceData": null,
        "DeviceDetails": null
      },

      {
        "infoType": "Assets",
        "infoData": null,
        "irRadianceData": null,
        "DeviceDetails": []
      },

      {
        "infoType": "Irradiance Info",
        "infoData": null,
        "irRadianceData": [],
        "DeviceDetails": null
      }, {
        "infoType": "Income Details",
        "infoData": [
          { PropName: "Annual Income (INR)", PropValue: "" }],
        "irRadianceData": null,
        "DeviceDetails": null
      },
    ]
  })
  const next = (index) => {
    if(btnref.current || btn1ref.current || btn2ref.current || btn3ref.current || btn4ref.current ){
      btnref.current.disabled = true;
      btn1ref.current.disabled = true;
      btn2ref.current.disabled = true;
      btn3ref.current.disabled = true;
      btn4ref.current.disabled = true;

    let jsonBody = {}
    switch (index) {
      case 0:
        jsonBody = {
          customerId: selectedId,
          "personalData": formData.personalData
        }
        authCall.postCustomerprofile(sessionStorage.getItem("userId"), jsonBody).then(json => {
          if (json) {
            setSelectedId(json)
            document.getElementById('createCustomer-snackbar').open = true;
            setSnackBarObj({ type: "success", msg: "Data saved successfully." })
            return document.getElementById('se-stepper1').next(true);
          }
        })
          .catch(error => {
            console.log(error);
          });
        break;
      case 1:
        jsonBody = {
          customerId: selectedId,
          "detailsInfo": [{ "infoData": formData.detailsInfo[index - 1].infoData }]
        }
        authCall.postAgroLandDetails(sessionStorage.getItem("userId"), jsonBody).then(json => {
          if (json) {
            document.getElementById('createCustomer-snackbar').open = true;
            setSnackBarObj({ type: "success", msg: "Data saved successfully." })
            return document.getElementById('se-stepper1').next(true);
          }
        })
          .catch(error => {
            console.log(error);
          });
        break;
      case 2:
        jsonBody = {
          customerId: selectedId,
          "detailsInfo": [{ "infoData": formData.detailsInfo[index - 1].infoData }]
        }
        authCall.postAgroDriveDetails(sessionStorage.getItem("userId"), jsonBody).then(json => {
          if (json) {
            if (json === selectedId) {
              document.getElementById('createCustomer-snackbar').open = true;
              setSnackBarObj({ type: "success", msg: "Data saved successfully." })
              return document.getElementById('se-stepper1').next(true);
            } else {
              document.getElementById('createCustomer-snackbar').open = true;
              setSnackBarObj({ type: "error", msg: json })
            }
          }
        })
          .catch(error => {
            console.log(error);
          });
        break;
      case 3:
        setSelectedIndex(index)
        let copyFormData = JSON.parse(JSON.stringify(formData))
        let count = 0
        _.map(copyFormData.detailsInfo[index - 1].DeviceDetails, eachDevice => {
          count = count + 1
          eachDevice.PropId = count.toString()
        })
        setFormData(copyFormData)
        document.getElementById("dialog-load-Popup2").open = true;
        break;
      case 4:
        jsonBody = {
          customerId: selectedId,
          "detailsInfo": [{ "irRadianceData": formData.detailsInfo[index - 1].irRadianceData }]
        }
        authCall.postAgroIRRadianceDetails(sessionStorage.getItem("userId"), jsonBody).then(json => {
          if (json) {
            document.getElementById('createCustomer-snackbar').open = true;
            setSnackBarObj({ type: "success", msg: "Data saved successfully." })
            return document.getElementById('se-stepper1').next(true);
          }
        })
          .catch(error => {
            console.log(error);
          });
        break;
      case 5:
        jsonBody = {
          customerId: selectedId,
          "detailsInfo": [{ "infoData": formData.detailsInfo[index - 1].infoData }]
        }
        authCall.postAgroIncomeDetails(sessionStorage.getItem("userId"), jsonBody).then(json => {
          if (json) {
            document.getElementById('createCustomer-snackbar').open = true;
            setSnackBarObj({ type: "success", msg: "Customer Created Successfully." })
            setTimeout(() => {
              gotoMyCustomer()
            }, 1000);
          }
        })
          .catch(error => {
            console.log(error);
          });
        break;
    }
    }
  }
  const onLoadOk = () => {
    if (selectedIndex === 3) {
      let jsonBody = {
        "customerId": selectedId,
        "detailsInfo": [{ "DeviceDetails": formData.detailsInfo[2].DeviceDetails }]
      }
      authCall.postAgroDeviceDetails(sessionStorage.getItem("userId"), jsonBody).then(json => {
        if (json) {
          document.getElementById('createCustomer-snackbar').open = true;
          setSnackBarObj({ type: "success", msg: "Data saved successfully." })
          document.getElementById("dialog-load-Popup2").open = false;
          return document.getElementById('se-stepper1').next(true);
        }
      })
        .catch(error => {
          console.log(error);
        });
    }
  }
  const previous = (index) => {
    return document.getElementById('se-stepper1').previous(true);
  }
  const CustomerProfileChange = (callback) => {
    let copyInfoData = JSON.parse(JSON.stringify(formData))
    copyInfoData.personalData = callback
    setFormData(copyInfoData)

  }
  const getError = (callback) => {
    let tempArray = []
    let result = false;
    _.map(callback, ele => {
      if (ele.PropName !== "Customer Type") {
        tempArray.push(ele)
      }
    })
    for (let i in tempArray) {
      if (tempArray[i].PropValue === "" || tempArray[i].PropMsg) {
        result = true;
        break
      } else {
        result = false;
      }
    }
    setIsProfileError(result)
  }
  const onBlur = (callback, index) => {
    let copyInfoData = JSON.parse(JSON.stringify(formData))
    copyInfoData.detailsInfo[index].infoData = callback
    setFormData(copyInfoData)
    // console.log(formData)
  }
  const landDetailsError = (error) => {
    let result = false;
    for (let i in error) {
      if (error[i].PropValue === "" || error[i].PropMsg) {
        result = true;
        break
      } else {
        result = false;
      }
    }
    setIsLandError(result)
  }
  const gatewayInfoError = (error) => {
    let result = false;
    for (let i in error) {
      if (error[i].PropValue === "" || error[i].PropMsg) {
        result = true;
        break
      } else {
        result = false;
      }
    }
    setIsGateWayError(result)
  }
  const incomeDetailsError = (error) => {
    let result = false;
    for (let i in error) {
      if (error[i].PropMsg) {
        result = true;
        break
      } else {
        result = false;
      }
    }
    setIsIncomeError(result)
  }
  const onIrradianceChange = (callback, index) => {
    let copyInfoData = JSON.parse(JSON.stringify(formData))
    copyInfoData.detailsInfo[index].irRadianceData = callback
    setFormData(copyInfoData)
  }
  const irradianceDetailsError = (errors) => {
    let result = false;
    let tempArray = [];
    for (let j = 0; j < errors.length; j++) {
      if (result === true) { break; }
      for (let i = 0; i < errors[j]["data"].length; i++) {
        if (errors[j]["data"][i].PropMsg) {
          tempArray[3] = true
          break;
        } else {
          tempArray[3] = false
        }
      }
      result = _.find(tempArray, (o => { if (o === true) { return true; } }));
    }
    setIsIrradianceError(result)
  }
  const gotoMyCustomer = () => {
    let { history } = props;
    history.push({
      pathname: '/mycustomers'
    });
  }
  const onAssetsChange = (data, errors) => {
    console.log(errors)
    // debugger
    _.map(data, (ele, index) => {
      ele.PropId = (index + 1).toString()
    })
    formData.detailsInfo[2].DeviceDetails = data
    let result = false;
    for (let i in errors) {
      for (let j in errors[i].PropData) {
        if (errors[i].PropData[j].PropName !== "Asset Type"
          && errors[i].PropData[j].PropName !== "Type"
          && errors[i].PropData[j].PropName !== "Enter Power Vs Water flow data") {
            if(errors[i].PropData[j].PropValue === "" && (errors[i].PropData[j].PropName === "Motor Power"|| errors[i].PropData[j].PropName === "Frequency"||errors[i].PropData[j].PropName === "Water Discharge/hr " ||errors[i].PropData[j].PropName === "Water Discharge/hr"))
          {
              // console.log("test")
              
          }
          else if (errors[i].PropData[j].PropValue === "" || errors[i].PropData[j].PropMsg !== "") {
            result = true
            break;
          }
        }
      }
    }
    setIsAssetsError(result)
  }
  const renderLoadTerminal = () => {
    return _.map(formData.detailsInfo[2].DeviceDetails, eachDevice => {
      return <><div><strong>{_.find(eachDevice.PropData, ['PropName', "Asset Type"]).PropValue}</strong>  connected to <strong>Load - {eachDevice.PropId}</strong> terminal</div><br></br></>
    })
  }
  React.useEffect(() => {
    setFormData(formData)
  }, [formData])
  const renderStepperItem = _.map(stepperList, (ele, index) => {
    return <se-stepper-item label={ele}>
      <se-container option="centered">
        <div class="row px-4 pt-2 pb-2" >
          <se-block option="widget" class="createUserWidgetHeight">
            {index === 0 ?
              <se-container display="grid" padding="large">
                <CustomerProfile2 onChange={CustomerProfileChange} isError={getError}
                  personalData={formData.personalData} disabledIcon={true} />
              </se-container> : null}
            {index === 1 ? <se-container display="grid" padding="large">
              <LandDetailsWithMap index={index - 1} onChange={landDetailsError} onBlur={onBlur}
                infoData={formData.detailsInfo[index - 1].infoData} isDisabled={false} disabeldGraph={false} />
            </se-container> : null}
            {index === 2 ? <se-container display="grid" padding="large"><LandDetails2 index={index - 1}
              onChange={gatewayInfoError} onBlur={onBlur}
              infoData={formData.detailsInfo[index - 1].infoData}
              disabeldGraph={true} /></se-container> : null}
            {index === 3 ? <se-container display="grid" padding="large">
              <AddAssets index={index - 1} disabledIcon={true} onChange={onAssetsChange}
                DeviceDetails={formData.detailsInfo[index - 1].DeviceDetails} />
            </se-container> : null}
            {index === 4 ? <se-container display="grid" padding="large">
              <IrradianceDetails
                onChange={irradianceDetailsError} onBlur={onIrradianceChange} index={index - 1}
                irRadianceData={formData.detailsInfo[index - 1].irRadianceData} />
            </se-container> : null}
            {index === 5 ? <se-container display="grid" padding="large"><LandDetails2 index={index - 1}
              onChange={incomeDetailsError} onBlur={onBlur}
              infoData={formData.detailsInfo[index - 1].infoData}
              disabeldGraph={true} /></se-container> : null}
            <se-block-footer>
              <div class="col-md-6 pl-2 pt-2"></div>
              {index === 0 ? <div class="col-md-6 text-right">
                <se-button ref={btnref} disabled={isProfileError}
                  onClick={() => next(index)}>Next</se-button></div> : null}
              {index === 1 ? <div class="col-md-6 text-right">
                <se-button onClick={() => previous()}>Previous</se-button>
                <se-button ref={btn1ref} disabled={isLandError}
                  onClick={() => next(index)}>Next</se-button></div> : null}
              {index === 2 ? <div class="col-md-6 text-right">
                <se-button onClick={() => previous()}>Previous</se-button>
                <se-button ref={btn2ref} disabled={isGateWayError}
                  onClick={() => next(index)}>Next</se-button></div> : null}
              {index === 3 ? <div class="col-md-6 text-right">
                <se-button onClick={() => previous()}>Previous</se-button>
                <se-button ref={btn3ref} disabled={isAssetsError}
                  onClick={() => next(index)}>Next</se-button></div> : null}
              {index === 4 ? <div class="col-md-6 text-right">
                <se-button onClick={() => previous()}>Previous</se-button>
                <se-button ref={btn4ref} disabled={isIrradianceError} onClick={() => next(index)}>Next</se-button>
              </div> : null}
              {index === 5 ? <div class="col-md-6 text-right">
                <se-button onClick={() => previous()}>Previous</se-button>
                <se-button disabled={isIncomeError} onClick={() => next(index)}>Save</se-button>
              </div> : null}
            </se-block-footer>
          </se-block>
        </div>
      </se-container>
    </se-stepper-item>
  })
  return <se-container class="grey-backgroundCreate">
    <se-container position="absolute" direction="column">
      <se-block-header class="headerColor"><span class="font-size-22">New Customer</span>
        <div slot="end"><se-icon option="" class="pointer" onClick={() => gotoMyCustomer()}>action_close</se-icon>&nbsp;&nbsp;&nbsp;&nbsp;</div>
      </se-block-header>
      <se-container option="centered">
        <se-stepper id="se-stepper1" linear='true'>
          {renderStepperItem}
        </se-stepper>
      </se-container>
      <se-dialog id="dialog-load-Popup2" color="alternative" can-backdrop="false" size="small">
        <se-container style={{ display: "block" }} padding="large">
          {renderLoadTerminal()}
        </se-container>
        <se-dialog-footer>
          <se-button onClick={() => onLoadOk()}>Ok</se-button>
        </se-dialog-footer>
      </se-dialog>
      <div class="paddingLeft300" align="left">
        <se-snackbar id="createCustomer-snackbar" duration="5000" type={snackBarObj.type}
          message={snackBarObj.msg} ></se-snackbar>
      </div>
    </se-container>
  </se-container>
}
export default CreateNewUser;